import request from "../request.js";

export function savePageTemplate(data) {
    return request({
        url: "/postTemplate",
        method: "POST",
        data: data
    });
}

export function fetchPageTemplates(query) {
    let page = "Page";
    return request({
        url: "/postTemplate/givenCategName/" + page,
        method: "get"
    });
}

export function fetchPageTemplates_2(query) {

    return request({
        url: "/postTemplate/",
        method: "get"
    });
}


export function getUser(userID) {
    return request({
        url: "/user/" + userID + "/" + 3,
        method: "get"
    });
}

export function getFormDetail(formID) {
    return request({
        url: "/form/" + formID,
        method: "get"
    });
}

export function fetchPageTemplate(id) {
    return request({
        url: "/postTemplate/" + id,
        method: "get"
    });
}

export function fetchPageTemplateByCategory(categoryName) {
    return request({
        url: "/postTemplate/givenCategName/" + categoryName,
        method: "get"
    });
}
